import { NewFixedProductSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { CreateInvoiceSettingsSchema } from './create-invoice-settings-schema';

export const CreateInvoiceRequestSchema = oz.object({
  fixedProducts: oz.array(NewFixedProductSchema),
  settings: CreateInvoiceSettingsSchema,
}).openapi('CreateInvoiceRequest');

export type CreateInvoiceRequestPayload = oz.infer<typeof CreateInvoiceRequestSchema>;